<template>
    <div class="menu-section">
<vue-basic-alert :duration="400" :timeout="1000" ref="alert" />
<div v-if="!user" >
            <div class="register-form-container">
                <br> <br> <br> <br> <br>
                <div class="heading">
                <span>Please Loging First.....</span>
                <h3><router-link class="btn dark" @click="scrollToTop()" to="/login">Login</router-link></h3>
                </div>
            <h3><b></b></h3>
            </div>
        </div>

<div v-else class="shroff-container">
       <div class="shroff-form-container">
        <form id="ShopRentForm"  novalidate autocomplete="off">
         <div class="row">
            <div  class="col-sm-10 "></div>
            <div  class="col-sm-2 ">
                    <router-link to="/assessmentpayhistory" v-slot="{ href, navigate }">
                <div v-if="user" class="fas fa-history  icons" style="background: #dc380a;color: white;" @click="showLog">
                    <h5 @click="scrollToTop(), navigate,href">Payment History</h5>
                </div>
                </router-link>
            </div>
           </div>
         
            <b><h3>Assessment Tax </h3></b>
         
           <div class="row">
            <h4>For payment of assessment tax related to your assets, select the council where your assets belong</h4>
           </div>
           <br>
            <div class="row">
                <div class="col-sm-12">
                    <label id="uPradeshiya"><b>Select Pradeshiya Sabha :</b>
                    </label>
                            <select @change=AllShopData class="form-control" name="pradeshiya" id="pradeshiya" v-model="rentObj.pra_sabha" >
                                <option value="" selected disabled>Choose</option>
                                <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">{{ ps.sb_name_en}}&nbsp;&nbsp;|&nbsp;&nbsp;{{ ps.sb_name_sin }} </option>
                            </select>
                            <p class="error-mess" v-if="errorObj.praErr.length > 0">{{ errorObj.praErr[0] }}</p>
                </div>
            </div> 
            
            <div id="pay" style="display: none;">
               <br>
                                <div class="row">
                                    <h4>Complete the following information against the Form K you have received to Search property</h4>
                               </div>
                                <br>
            <div class="row">
                   <div class="col-sm-2">  
                            <label for="ward"><b>Ward Number  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</b></label>
                     <select v-model="CatObj.ward" id="ward" class="form-control"  @change="SearchByward()" size="5">
                          <option value="" selected disabled>Choose</option>
                          <option v-for="m in savedWards" :key="m.ward_id" id="Hid" v-bind:value=m.ward_id>
                             <div>{{m.ward }}</div> 
                          </option>
                      </select>
                     <p class="error-mess" v-if="aserrObj.wardErr.length > 0">{{ aserrObj.wardErr[0] }}</p>
                  </div>
                  <div class="col-sm-4">  
                            <label for="street"><b>Name of Road,or Street  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</b></label>
                     <select v-model="CatObj.street" id="street" class="form-control" @change="SearchByraod()" size="5">
                          <option value="" selected disabled>Choose</option>
                          <option v-for="m in savedStreets" :key="m.street_id" id="Hid" v-bind:value=m.street_id>
                             <div>{{m.street_name }}</div> 
                          </option>
                      </select>
                      <p class="error-mess" v-if="aserrObj.stretErr.length > 0">{{ aserrObj.stretErr[0] }}</p>
                  </div>
                  <div class="col-sm-3">
                 <label for="cat"><b>Select Main Category:</b></label>
                    <select v-model="CatObj.mainc" id="cat" class="form-control"  @change="SearchByCat()" size="5">
                          <option value="" selected disabled>Choose</option>
                          <option v-for="m in maincate" :key="m.cat_id" id="Hid" v-bind:value=m.cat_id>
                             <div>{{m.category_name }}</div> 
                          </option>
                      </select>
                 <p class="error-mess" v-if="aserrObj.maincErr.length > 0">{{ aserrObj.maincErr[0] }}</p>
             </div>
             <div class="col-sm-3">
                 <label for="cat"><b>Select Assessment Number:</b></label>
                    <select v-model="CatObj.assenum" id="cat" class="form-control" size="5">
                          <option value="" selected disabled>Choose</option>
                          <option v-for="m in propertydetails" :key="m.property_id" id="Hid" v-bind:value=m.property_id>
                             <div>{{m.asses_num }}</div> 
                          </option>
                      </select>
             </div>
            </div>
            <br>
            <div class="row">
                    <h4>Search by K Form Reference Number</h4>
            </div>
            <div class="row">                    
                    <div class="col-sm-3">
                        <label for="usedn"> Property ID:</label>
                        <div>
                        <input 
                        v-model="CatObj.assenum" 
                        id="serchprop" 
                        list="sabaPropList" 
                        class="form-control"
                        placeholder="Choose or type a property ID"
                        />
                        <datalist id="sabaPropList">
                        <option v-for="p in sabaProp" :key="p.property_id" :value="p.property_id"></option>
                        </datalist>
                    </div>
                    </div>
                    <div class="Addbtn col-sm-3">
                   <input type="button" value="Search" id="secbtn" class=" btn" @click="populateCustomerDetails()"  /> 
                    </div>
                </div>
            <br>

          <!-- ── Property Details Panel ── -->
          <template v-for="p in propDetails" :key="p.property_id">
            <div class="row">
               <div class="col-sm-6">
               <h4>Form K Reference Number(Property ID): {{ CatObj.assenum }}</h4>
            </div>
            </div>
            <div class="row">
                  <div class="col-sm-6">
                     <h4>Property Owner(s) : <input name="cName" id="cName" class="form-group" v-model="cusObj.name" rows="2" readonly></h4>
                  </div>
                     <div class="col-sm-6">
                         <h4>Property Address : <input name="cAddress" class="form-group" id="cAddress" v-model="cusObj.address" readonly></h4>
                     </div>
            </div>
            <br>

            <!-- Arrears / Excess -->
            <div class="row">
             <div class="form-group col-sm-4">
                <label for="parr">Arrears/Excess Amount:</label>
                <input type="text" id="parr" class="form-control" v-model="cusObj.arre" readonly> 
              </div>
            </div>

            <!-- Annual payment option — only available in January -->
            <div class="row">
               <div class="col-sm-6">
                  <div class="form-group d-flex align-items-center mb-2">
                  <label for="checkboxannual" style="width: 200px;"><b>Pay Full Annual Amount</b></label>&nbsp;
                  <input type="checkbox" id="checkboxannual" v-model="Annualchecked" @change="handleCheckboxChange" />
                </div>
                <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
                <div class="form-group" id="yrvalforann" v-show="Annualchecked">
                  <label for="fqp" class="me-2" style="width: 180px;">Yearly Value:</label>
                  <input type="text" id="annval" class="form-control" v-model="cusObj.yearlyval" style="width: auto;" readonly />
                </div> 
                <div class="form-group" id="discforann" v-show="Annualchecked">
                  <label for="fqp" class="me-2" style="width: 180px;">Discount Value:</label>
                  <input type="text" id="anndis" class="form-control" v-model="cusObj.discval" style="width: auto;" readonly />
                </div>
               </div>
            </div>
            <br>

            <!-- Quarter table header -->
            <div class="row" style="text-align: center;">
              <div class="form-group col-sm-1"><label><b>Quarter</b></label></div>
              <div class="form-group col-sm-2"><label><b>Quarter Payments</b></label></div>
              <div class="form-group col-sm-2"><label><b>Discount</b></label></div>
              <div class="form-group col-sm-2"><label><b>Fine</b></label></div>
              <div class="form-group col-sm-2"><label><b>Amount to Pay</b></label></div>
              <div class="form-group col-sm-1"><label><b>Pay</b></label></div>
            </div>

            <!-- Q1 -->
            <div class="row">
              <div class="form-group col-sm-1"><label>First</label></div>
              <div class="form-group col-sm-2">
                <input type="text" id="fqpay" class="form-control" v-model="cusObj.fq" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="fqdisc" class="form-control" :value="q1Values.discount" placeholder="Discount" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="fqfine" class="form-control" :value="q1Values.fine" placeholder="Fine" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="fqamt" class="form-control" :value="q1Values.cashNeeded" placeholder="Amount to Pay" readonly/>
              </div>
              <div class="form-group col-sm-1">
                <input type="checkbox" id="checkboxqone" class="form-control" v-model="qonecheck"
                  @change="qoneChecked()"
                  :disabled="paymentData[p.property_id] && paymentData[p.property_id][1] && paymentData[p.property_id][1][0]==='Paid'" />
              </div>
              <div class="form-group col-sm-1">
                <span v-if="paymentData[p.property_id] && paymentData[p.property_id][1] && paymentData[p.property_id][1][0]==='Paid'" class="ms-2 text-success">Paid</span>
              </div>
            </div>
            <p v-if="qOneErrorMessage" class="text-danger">{{ qOneErrorMessage }}</p>

            <!-- Q2 -->
            <div class="row">
              <div class="form-group col-sm-1"><label>Second</label></div>
              <div class="form-group col-sm-2">
                <input type="text" id="sqpay" class="form-control" v-model="cusObj.sq" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="sqdisc" class="form-control" :value="q2Values.discount" placeholder="Discount" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="sqfine" class="form-control" :value="q2Values.fine" placeholder="Fine" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="sqamt" class="form-control" :value="q2Values.cashNeeded" placeholder="Amount to Pay" readonly/>
              </div>
              <div class="form-group col-sm-1">
                <input type="checkbox" id="checkboxqtwo" class="form-control" v-model="qtwocheck"
                  @change="qtwoChecked()"
                  :disabled="paymentData[p.property_id] && paymentData[p.property_id][2] && paymentData[p.property_id][2][0]==='Paid'" />
              </div>
              <div class="form-group col-sm-1">
                <span v-if="paymentData[p.property_id] && paymentData[p.property_id][2] && paymentData[p.property_id][2][0]==='Paid'" class="ms-2 text-success">Paid</span>
              </div>
            </div>
            <p v-if="qtwoErrorMessage" class="text-danger">{{ qtwoErrorMessage }}</p>

            <!-- Q3 -->
            <div class="row">
              <div class="form-group col-sm-1"><label>Third</label></div>
              <div class="form-group col-sm-2">
                <input type="text" id="tqpay" class="form-control" v-model="cusObj.tq" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="tqdisc" class="form-control" :value="q3Values.discount" placeholder="Discount" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="tqfine" class="form-control" :value="q3Values.fine" placeholder="Fine" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="tqamt" class="form-control" :value="q3Values.cashNeeded" placeholder="Amount to Pay" readonly/>
              </div>
              <div class="form-group col-sm-1">
                <input type="checkbox" id="checkboxqthree" ref="qthrecheck" class="form-control" v-model="qthrecheck"
                  @change="qthreeChecked()"
                  :disabled="paymentData[p.property_id] && paymentData[p.property_id][3] && paymentData[p.property_id][3][0]==='Paid'" />
              </div>
              <div class="form-group col-sm-1">
                <span v-if="paymentData[p.property_id] && paymentData[p.property_id][3] && paymentData[p.property_id][3][0]==='Paid'" class="ms-2 text-success">Paid</span>
              </div>
            </div>
            <p v-if="qthreeErrorMessage" class="text-danger">{{ qthreeErrorMessage }}</p>

            <!-- Q4 -->
            <div class="row">
              <div class="form-group col-sm-1"><label>Fourth</label></div>
              <div class="form-group col-sm-2">
                <input type="text" id="foqpay" class="form-control" v-model="cusObj.foq" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="foqdisc" class="form-control" :value="q4Values.discount" placeholder="Discount" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="foqfine" class="form-control" :value="q4Values.fine" placeholder="Fine" readonly/>
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="foqamt" class="form-control" :value="q4Values.cashNeeded" placeholder="Amount to Pay" readonly/>
              </div>
              <div class="form-group col-sm-1">
                <input type="checkbox" id="checkboxqfour" class="form-control" v-model="qfourcheck"
                  @change="qfourChecked()"
                  :disabled="paymentData[p.property_id] && paymentData[p.property_id][4] && paymentData[p.property_id][4][0]==='Paid'" />
              </div>
              <div class="form-group col-sm-1">
                <span v-if="paymentData[p.property_id] && paymentData[p.property_id][4] && paymentData[p.property_id][4][0]==='Paid'" class="ms-2 text-success">Paid</span>
              </div>
            </div>
            <p v-if="qfourerrorMessage" class="text-danger">{{ qfourerrorMessage }}</p>

            <hr>

            <!-- Totals row -->
            <div class="row" style="text-align: center;">
              <div class="form-group col-sm-1"><label><b>Total</b></label></div>
              <div class="form-group col-sm-2">
                <input type="text" id="totalqpay" class="form-control" :value="totalQuarterPayment" readonly />
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="totaldis" class="form-control" :value="totalDiscount" style="font-weight: bold;" readonly />
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="totalfine" class="form-control" :value="totalFine" style="font-weight: bold;" readonly />
              </div>
              <div class="form-group col-sm-2">
                <input type="text" id="totalamount" class="form-control" :value="totalAmount" style="font-weight: bold;" readonly />
              </div>
            </div>

          </template>

          <br>   
           <div class="row">
            <div class="col-sm-12">
                    <input type="button" value="Continue>>" class="btn" @click="Continuetoinvoice()" />
            </div>
           </div>
        </div>

           <br>
           </form>

           <!-- ── Invoice Panel ── -->
           <div id="taxinvoice" style="display: none;" class="invoice">
            <template v-for="p in propDetails" :key="p.property_id">
            <form @submit.prevent="submitForm" id="taxInvoince" novalidate autocomplete="off">
                <pre>DateTime :{{ new Date(this.serverDate).toLocaleString()}}</pre>
                <div class="heading">
                    <h3>Local Government Online Payment Management System</h3>
                    <h3><b>Payment Receipt</b></h3>
                    <h5 v-if="theSabhaData && theSabhaData[0]">{{ theSabhaData[0].sb_address }}</h5> 
                    <h5 v-if="theSabhaData && theSabhaData[0]">Tel:{{ theSabhaData[0].sb_contact}}, Fax:{{ theSabhaData[0].fax}}</h5> 
                </div>
                <div class="table-responsive">
                  <h4>Invoice No : &nbsp;{{ InvouceNum }} </h4>
                <table class="table">
                    <tbody>
                        <tr>
                            <td class="bg-light-gray"><label><b>Asset Owner(s):</b></label></td>
                            <td><label>{{ cusObj.name }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Asset Address:</b></label></td>
                            <td><label>{{ cusObj.address }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Ward Number:</b></label></td>
                            <td><label>{{ getWardName(CatObj.ward) }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Name of Road, or Street:</b></label></td>
                            <td><label>{{ getStreetName(CatObj.street) }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Assessment Number/Used Number:</b></label></td>
                            <td><label>{{ this.assnum }} / {{ this.usedNum }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>K Form Reference Number:</b></label></td>
                            <td><label>{{ CatObj.assenum }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Arrears/Excess Amount (Rs.):</b></label></td>
                            <td><label>{{ cusObj.arre }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Quarter Amount (Rs.):</b></label></td>
                            <td><label>{{ totalAmountPayQ }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Assessment Fine (Rs.):</b></label></td>
                            <td><label>{{ totalFine }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Assessment Discount (Rs.):</b></label></td>
                            <td><label>{{ totalDiscount }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Payable Amount (Rs.):</b></label></td>
                            <td><label>{{ paybleAmount }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Banking Service Charge (Rs.)</b></label></td>
                            <td><label>{{ bankfee }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Grand Total (Rs.)</b></label></td>
                            <td><label>{{ grandPayTotal }}</label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label><b>Description</b></label></td>
                            <td><label>{{ descriptionText }}</label></td>
                        </tr>
                    </tbody>
                </table>
                </div>
             
            <div class="table-responsive">  
                <input @click="btnenable" type="checkbox" id="checkid" v-model="checkVal">
                  &nbsp;I certify that the above information is true and correct.
            </div><br>
            <div class="form-group aling table-responsive" v-if="theSabhaData && theSabhaData[0] && theSabhaData[0].saba_ipg=='BOC'">
                <button class="btn" id="payboc" type="submit" :disabled="disableButton">Pay Now</button>
            </div>
            </form>
          </template>
            <br>
            <div v-html="form" id="formResponse" class="form-group aling" style="display: none;"></div><br>
            </div>
       </div>
</div>
    </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert'

export default {
   name: "AssessmentTaxNew",

   data() {
        return {
          form: '',
            userNic:'', Nic:'',
            rentObj: { pro:"", dis:"", pra_sabha:"", paydes:"", taxNum:"", Payment:"", street:"", ward:"" },
            errorObj: { disErr:[], proErr:[], praErr:[], paydesErr:[], taxNumErr:[], streetErr:[], wardErr:[], PaymentErr:[] },
            p_sabha:[],
            SabhaData: undefined,
            Sabha: undefined,
            matchUser: undefined,
            matchPaymonth:[],
            AllShopDtails:[],
            Districts:[],
            DistrictsData: undefined,
            sDist: undefined,
            province:[], onlinPaydata:[],
            len:0, len2:0,
            lastGennum: null,
            nextid:'',
            sabhaCode:'',

            nic:"", sabha:"", userLevel:"",
            CatObj: { ward:"", street:"", mainc:"", propsearch:"", assenum:"" },
            aserrObj: { wardErr:[], stretErr:[], maincErr:[] },
            savedWards:[], savedStreets:[],
            itemsPerPage: 10, currentPage: 1,
            maincate:[], sabaProp:[], propertydetails:[],
            showtbl: false, showtblpro: false,
            selectedProperty: null,

            cusObj: {
              name:"", address:"", headid:"", descr:"", arre:"0.00",
              relper:"0", fq:"", sq:"", tq:"", foq:"",
              yearlyval:"", discval:"", payamountqaurter:0,
              finevot:"", arreasvot:""
            },
            cusErrObj: {
              nameErr:[], addErr:[], headidErr:[], descrErr:[],
              monthendErr:[], iheadErr:[], fineheadErr:[], arreheadErr:[], amountpaidErr:[]
            },

            amountpaid:0,
            ownerdetails:[], sabhaIncomeHead:[], propDetails:[],
            paymentData:{},
            responseData:[], Relchecked: false, propertyde:[],
            Annualchecked: false, errorMessage:"",
            qonecheck: false, qOneErrorMessage:"",
            qtwoErrorMessage:"", qtwocheck: false,
            qthreeErrorMessage:"", qthrecheck: false,
            qfourerrorMessage:"", qfourcheck: false,
            allreceipt:[], arrearsAmount:0, pamentArreas:[],
            isReadonly: true, notpaidQuaters:[],
            assnum:'', asspropId:0, totalqtpayment:0,
            descriptionInput:'', assdiscount:0, usedNum:'',
            serverDate:'',

            grandPayTotal:0, bankfee:0,
            cusName:'', Sname:'', monthName:'',
            checkVal:'', sessionData:'', InvouceNum:'',
            sabha_code:'', remark:'', taxtPayment:'', taxNo:'',
            pay_head:0,
            payamount:{},
            theSabhaData:[],
            shopDeID:[], temp:[],
            postData: {
                mid:'', paytype:'', amount:'', referenceNumber:'',
                email:'', bill_to_forename:'', bill_to_surname:'',
                bill_to_address_line1:'', bill_to_address_city:'',
                bill_to_address_state:'', bill_to_address_postal_code:'',
                bill_to_address_country:'LK',
            },
            response: null, error: null,
            currentDate: new Date(),
            fine:0, totalshoprent:0,
            Checkout: null,
            pay_vote:'assessmenttax',
            ward:'', street:'',
            formData: {
                boc_sid:'', boc_paytype:'', boc_amount:'', boc_grandamount:'',
                boc_cus_nic:'', boc_invoice:'', boc_remarks:'',
                country:'', street:'', street2:'', city:'', state:'', zip:'',
            },
            ipg:'', disableButton: true,
            assessVote:'', assessArrearsVote:'', assessFineVote:'',

            // ── PIV-accurate state ──
            calArrears: 0,
        }
    },

    created() {
        this.getSessionData();
        this.AllprSabha();
    },

    computed: {
        ...mapState(["user"]),

        // ─────────────────────────────────────────────────────────────────
        // Per-quarter computed values using PIV's getQuarterCost logic
        // ─────────────────────────────────────────────────────────────────
        currentMonthComputed() {
            return new Date(this.serverDate).getMonth() + 1;
        },
        warrantRateComputed() {
            return this.floorToTwo(this.propDetails?.[0]?.warrant_cost_rate || 20);
        },
        tableAreExValComputed() {
            return this.floorToTwo(this.propDetails?.[0]?.arrears_val || 0);
        },
        remainingExcessComputed() {
            return this.tableAreExValComputed < 0 ? Math.abs(this.tableAreExValComputed) : 0;
        },

        q1Values() {
            if (!this.qonecheck || !this.cusObj.fq) return { discount: "", fine: "", cashNeeded: "" };
            const qc = this.getQuarterCost(1, parseFloat(this.cusObj.fq) || 0, this.currentMonthComputed, this.warrantRateComputed, this.remainingExcessComputed);
            return {
                discount: qc.discount > 0 ? this.roundToTwo(qc.discount).toFixed(2) : "0",
                fine:     qc.fine > 0     ? this.roundToTwo(qc.fine).toFixed(2)     : "0",
                cashNeeded: this.roundToTwo(qc.cashNeeded).toFixed(2),
            };
        },
        q2Values() {
            if (!this.qtwocheck || !this.cusObj.sq) return { discount: "", fine: "", cashNeeded: "" };
            // excess already consumed by q1 if q1 was checked
            const excessAfterQ1 = this.qonecheck
                ? this.floorToTwo(Math.max(0, this.remainingExcessComputed - this.getQuarterCost(1, parseFloat(this.cusObj.fq)||0, this.currentMonthComputed, this.warrantRateComputed, this.remainingExcessComputed).excessUsed))
                : this.remainingExcessComputed;
            const qc = this.getQuarterCost(2, parseFloat(this.cusObj.sq) || 0, this.currentMonthComputed, this.warrantRateComputed, excessAfterQ1);
            return {
                discount: qc.discount > 0 ? this.roundToTwo(qc.discount).toFixed(2) : "0",
                fine:     qc.fine > 0     ? this.roundToTwo(qc.fine).toFixed(2)     : "0",
                cashNeeded: this.roundToTwo(qc.cashNeeded).toFixed(2),
            };
        },
        q3Values() {
            if (!this.qthrecheck || !this.cusObj.tq) return { discount: "", fine: "", cashNeeded: "" };
            let excess = this.remainingExcessComputed;
            if (this.qonecheck) excess = this.floorToTwo(Math.max(0, excess - this.getQuarterCost(1, parseFloat(this.cusObj.fq)||0, this.currentMonthComputed, this.warrantRateComputed, excess).excessUsed));
            if (this.qtwocheck) excess = this.floorToTwo(Math.max(0, excess - this.getQuarterCost(2, parseFloat(this.cusObj.sq)||0, this.currentMonthComputed, this.warrantRateComputed, excess).excessUsed));
            const qc = this.getQuarterCost(3, parseFloat(this.cusObj.tq) || 0, this.currentMonthComputed, this.warrantRateComputed, excess);
            return {
                discount: qc.discount > 0 ? this.roundToTwo(qc.discount).toFixed(2) : "0",
                fine:     qc.fine > 0     ? this.roundToTwo(qc.fine).toFixed(2)     : "0",
                cashNeeded: this.roundToTwo(qc.cashNeeded).toFixed(2),
            };
        },
        q4Values() {
            if (!this.qfourcheck || !this.cusObj.foq) return { discount: "", fine: "", cashNeeded: "" };
            let excess = this.remainingExcessComputed;
            if (this.qonecheck) excess = this.floorToTwo(Math.max(0, excess - this.getQuarterCost(1, parseFloat(this.cusObj.fq)||0, this.currentMonthComputed, this.warrantRateComputed, excess).excessUsed));
            if (this.qtwocheck) excess = this.floorToTwo(Math.max(0, excess - this.getQuarterCost(2, parseFloat(this.cusObj.sq)||0, this.currentMonthComputed, this.warrantRateComputed, excess).excessUsed));
            if (this.qthrecheck) excess = this.floorToTwo(Math.max(0, excess - this.getQuarterCost(3, parseFloat(this.cusObj.tq)||0, this.currentMonthComputed, this.warrantRateComputed, excess).excessUsed));
            const qc = this.getQuarterCost(4, parseFloat(this.cusObj.foq) || 0, this.currentMonthComputed, this.warrantRateComputed, excess);
            return {
                discount: qc.discount > 0 ? this.roundToTwo(qc.discount).toFixed(2) : "0",
                fine:     qc.fine > 0     ? this.roundToTwo(qc.fine).toFixed(2)     : "0",
                cashNeeded: this.roundToTwo(qc.cashNeeded).toFixed(2),
            };
        },

        // ── Totals (derived from q*Values so always consistent) ──
        totalQuarterPayment() {
            return (
                (parseFloat(this.cusObj.fq)  || 0) +
                (parseFloat(this.cusObj.sq)  || 0) +
                (parseFloat(this.cusObj.tq)  || 0) +
                (parseFloat(this.cusObj.foq) || 0)
            ).toFixed(2);
        },
        totalDiscount() {
            return this.roundToTwo(
                (parseFloat(this.q1Values.discount) || 0) +
                (parseFloat(this.q2Values.discount) || 0) +
                (parseFloat(this.q3Values.discount) || 0) +
                (parseFloat(this.q4Values.discount) || 0)
            ).toFixed(2);
        },
        totalFine() {
            return this.roundToTwo(
                (parseFloat(this.q1Values.fine) || 0) +
                (parseFloat(this.q2Values.fine) || 0) +
                (parseFloat(this.q3Values.fine) || 0) +
                (parseFloat(this.q4Values.fine) || 0)
            ).toFixed(2);
        },
        totalAmount() {
            // sum of per-quarter cashNeeded
            return this.roundToTwo(
                (parseFloat(this.q1Values.cashNeeded) || 0) +
                (parseFloat(this.q2Values.cashNeeded) || 0) +
                (parseFloat(this.q3Values.cashNeeded) || 0) +
                (parseFloat(this.q4Values.cashNeeded) || 0)
            ).toFixed(2);
        },
        // Quarter amount for invoice (base + discount - fine = gross billed before cash)
        totalAmountPayQ() {
            return this.roundToTwo(
                parseFloat(this.totalAmount) +
                parseFloat(this.totalDiscount) -
                parseFloat(this.totalFine)
            ).toFixed(2);
        },

        paybleAmount() {
            const arrears = parseFloat(this.cusObj.arre) || 0;
            const total   = parseFloat(this.totalAmount) || 0;
            if (this.Annualchecked) {
                // Annual: discounted yearly value ± arrears
                const discounted = parseFloat(this.cusObj.yearlyval) - parseFloat(this.cusObj.discval || 0);
                return this.roundToTwo(arrears > 0 ? discounted + arrears : discounted).toFixed(2);
            }
            return this.roundToTwo(arrears > 0 ? total + arrears : total).toFixed(2);
        },

        descriptionText() {
            let description = '';
            if (this.Annualchecked) {
                description += `Yearly Value: ${parseFloat(this.cusObj.yearlyval || 0).toFixed(2)}\n`;
                description += `Discount Amount: ${parseFloat(this.cusObj.discval  || 0).toFixed(2)}\n`;
            }
            const quarters = [
                { name:'Q1', payment: this.cusObj.fq,  vals: this.q1Values, checked: this.qonecheck  },
                { name:'Q2', payment: this.cusObj.sq,  vals: this.q2Values, checked: this.qtwocheck  },
                { name:'Q3', payment: this.cusObj.tq,  vals: this.q3Values, checked: this.qthrecheck },
                { name:'Q4', payment: this.cusObj.foq, vals: this.q4Values, checked: this.qfourcheck },
            ];
            quarters.forEach(q => {
                if (q.checked && q.vals.cashNeeded) {
                    description += `${q.name}: Payment: ${q.payment || "N/A"}\n`;
                }
            });
            return description || " ";
        },

        paginatedData() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex   = startIndex + this.itemsPerPage;
            if (Array.isArray(this.propertydetails)) return this.propertydetails.slice(startIndex, endIndex);
            return [];
        },
        totalPages() {
            return Math.ceil(this.propertydetails.length / this.itemsPerPage);
        },
    },

    watch: {
        propDetails: {
            handler(newVal) {
                if (Array.isArray(newVal) && newVal.length > 0) {
                    newVal.forEach(async (p) => {
                        try { await this.loadPaymentStatus(p.property_id); }
                        catch (error) { console.error(`Failed to load payment data for PID: ${p.property_id}`, error); }
                    });
                }
            },
            immediate: true,
            deep: true,
        },
        descriptionText(newVal) {
            this.descriptionInput = newVal;
        },
    },

    methods: {
        ...mapMutations(["setUser"]),

        // ═══════════════════════════════════════════════════════════════
        // ── Math helpers (ported exactly from AssessPIV) ──
        // ═══════════════════════════════════════════════════════════════

        floorToTwo(value) {
            return Math.floor(parseFloat(value) * 100) / 100;
        },

        roundToTwo(value) {
            return Math.round(parseFloat(value) * 100) / 100;
        },

        // Integer-safe percent: avoids IEEE 754 drift (e.g. 138.90 * 0.05 = 6.9449...)
        safePercent(amount, ratePercent) {
            const pennies       = Math.round(parseFloat(amount) * 100);
            const resultPennies = Math.round(pennies * ratePercent / 100);
            return resultPennies / 100;
        },

        formatCurrency(value) {
            return this.roundToTwo(value || 0).toFixed(2);
        },

        // ═══════════════════════════════════════════════════════════════
        // ── getQuarterCost (ported exactly from AssessPIV) ──
        // Quarter discount/fine windows:
        //   Q1: discount ≤ month 1,  overdue > month 3
        //   Q2: discount ≤ month 4,  overdue > month 6
        //   Q3: discount ≤ month 7,  overdue > month 9
        //   Q4: discount ≤ month 10, overdue > month 12 (never in practice)
        // ═══════════════════════════════════════════════════════════════
        getQuarterCost(quarterNum, installment, currentMonth, warrantRate, availableExcess = 0) {
            const starts    = [1, 4, 7, 10];
            const ends      = [3, 6, 9, 12];
            const s         = starts[quarterNum - 1];
            const e         = ends[quarterNum - 1];
            const baseAmount = this.roundToTwo(installment);

            // Discount period (payment before quarter starts)
            if (currentMonth <= s) {
                const discount   = this.safePercent(baseAmount, 5);
                const grossCost  = this.roundToTwo(baseAmount - discount);
                const excessUsed = this.roundToTwo(Math.min(availableExcess, grossCost));
                const cashNeeded = this.roundToTwo(grossCost - excessUsed);
                return { grossCost, cashNeeded, baseAmount, discount, fine: 0, excessUsed, type: 'discount' };
            }

            // Standard period (within quarter)
            if (currentMonth > s && currentMonth <= e) {
                const excessUsed = this.roundToTwo(Math.min(availableExcess, baseAmount));
                const cashNeeded = this.roundToTwo(baseAmount - excessUsed);
                return { grossCost: baseAmount, cashNeeded, baseAmount, discount: 0, fine: 0, excessUsed, type: 'standard' };
            }

            // Overdue (past quarter end) — fine on net-of-excess base
            const excessUsed = this.roundToTwo(Math.min(availableExcess, baseAmount));
            const netBase    = this.roundToTwo(baseAmount - excessUsed);
            const fine       = this.safePercent(netBase, this.roundToTwo(warrantRate || 0));
            const grossCost  = this.roundToTwo(netBase + fine);
            return { grossCost, cashNeeded: grossCost, baseAmount, discount: 0, fine, excessUsed, netBase, type: 'fine' };
        },

        // ═══════════════════════════════════════════════════════════════
        // ── loadPaymentStatus (ported from AssessPIV) ──
        // Uses last_paid_year / last_paid_quarter from property master
        // instead of querying per-quarter payment records.
        // ═══════════════════════════════════════════════════════════════
        async loadPaymentStatus(pid) {
            const curYear = new Date(this.serverDate).getFullYear();
            try {
                const propRes     = await axios.get(`/sabapropid/${this.sabha}/${pid}`);
                const prop        = propRes.data?.[0];
                const lastYear    = prop?.last_paid_year;
                const lastQuarter = prop?.last_paid_quarter;

                if (!this.paymentData[pid]) this.paymentData[pid] = {};

                if (lastYear < curYear) {
                    for (let q = 1; q <= 4; q++) this.paymentData[pid][q] = ["Not Paid", "Not Paid"];
                    return this.paymentData[pid];
                }
                if (lastYear == curYear && lastQuarter == 4) {
                    for (let q = 1; q <= 4; q++) this.paymentData[pid][q] = ["Paid", "0.00"];
                    return this.paymentData[pid];
                }
                if (lastYear == curYear) {
                    for (let q = 1; q <= 4; q++)
                        this.paymentData[pid][q] = q <= lastQuarter ? ["Paid", "0.00"] : ["Not Paid", "Not Paid"];
                    return this.paymentData[pid];
                }
            } catch (e) {
                console.error(e);
                if (!this.paymentData[pid]) this.paymentData[pid] = {};
                for (let q = 1; q <= 4; q++) this.paymentData[pid][q] = ["Error", "Error"];
                return this.paymentData[pid];
            }
        },

        // ═══════════════════════════════════════════════════════════════
        // ── calculateArrears (ported from AssessPIV) ──
        // ═══════════════════════════════════════════════════════════════
        async calculateArrears(property) {
            try {
                const res = (await axios.get(`/sabapropid/${this.sabha}/${property}`)).data;
                if (!res || !res.length) return;
                const prop    = res[0];
                const avail   = this.floorToTwo(prop.arrears_val) || 0;
                const curYear = new Date(this.serverDate).getFullYear();
                const lastQ   = parseInt(prop.last_paid_quarter) || 0;
                const lastY   = parseInt(prop.last_paid_year) || 0;
                const qVals   = {
                    1: parseFloat(prop.q_one_val)   || 0,
                    2: parseFloat(prop.q_two_val)   || 0,
                    3: parseFloat(prop.q_three_val) || 0,
                    4: parseFloat(prop.q_four_val)  || 0
                };
                const wc = (parseFloat(prop.warrant_cost_rate) || 0) / 100;
                let lastarr = 0;
                if (lastY < curYear && lastY > 0) {
                    for (let q = lastQ + 1; q <= 4; q++) lastarr += qVals[q] + this.floorToTwo(qVals[q] * wc);
                    const fy = curYear - lastY - 1;
                    if (fy > 0) {
                        const oneYear = [1,2,3,4].reduce((s,q) => s + qVals[q] + this.floorToTwo(qVals[q] * wc), 0);
                        lastarr += fy * oneYear;
                    }
                }
                this.cusObj.arre = this.floorToTwo(avail + lastarr).toFixed(2);
                this.calArrears  = this.floorToTwo(lastarr);
            } catch (e) {
                console.error("Error calculating arrears:", e);
            }
        },

        // ═══════════════════════════════════════════════════════════════
        // ── Session / Init ──
        // ═══════════════════════════════════════════════════════════════
        async MatchUser(nic) {
            let data = await axios.get('/customersdata/' + nic);
            this.matchUser = data.data;
        },

        async getSessionData() {
            const data = JSON.parse(sessionStorage.getItem('Userdata'));
            if (data) { this.Nic = data.Unic; this.sabhaCode = data.Usabha; }
            await this.MatchUser(this.Nic);
            this.setUser(this.matchUser);
            await axios.delete('/deletetasstempbynic/' + this.user.cus_nic);
            await axios.delete('/onlinepaymenttemp/' + this.user.cus_nic);
            try {
                const response  = await axios.get('/getserverdate');
                this.serverDate = response.data.serverDate;
            } catch (error) {
                console.error("Error fetching server date:", error);
            }
        },

        formattedDate() {
            let date  = new Date(this.serverDate);
            const year  = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day   = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        // ═══════════════════════════════════════════════════════════════
        // ── Sabha / Property loading ──
        // ═══════════════════════════════════════════════════════════════
        async AllprSabha() {
            try {
                const allsabhaResponse = await axios.get('/customersabha/' + this.Nic);
                const allsabha = allsabhaResponse.data;
                if (allsabha && allsabha.length > 0) {
                    this.p_sabha = [];
                    for (const sabha of allsabha) {
                        if (sabha.sabha) {
                            const psabhaResponse = await axios.get('/PraSabhadata/' + sabha.sabha);
                            this.p_sabha.push(...psabhaResponse.data);
                        }
                    }
                }
            } catch (error) {
                console.error('Error fetching sabha data:', error);
            }
        },

        async AllShopData() {
            this.sabha = this.rentObj.pra_sabha;
            this.CatObj.assenum = "";
            this.propDetails = [];
            this.Annualchecked = false; this.errorMessage = "";
            this.qonecheck = false; this.qOneErrorMessage = "";
            this.qtwoErrorMessage = ""; this.qtwocheck = false;
            this.qthreeErrorMessage = ""; this.qthrecheck = false;
            this.qfourerrorMessage = ""; this.qfourcheck = false;
            this.allreceipt = []; this.arrearsAmount = 0;
            document.getElementById('pay').style.display = 'block';
            this.maincate     = (await axios.get('/maincat/')).data;
            this.savedWards   = (await axios.get('/wdbys/' + this.rentObj.pra_sabha)).data;
            this.savedStreets = (await axios.get('/stbys/' + this.rentObj.pra_sabha)).data;
            try {
                this.sabaProp        = (await axios.get('/props/' + this.rentObj.pra_sabha)).data;
                this.propertydetails = (await axios.get('/props/' + this.rentObj.pra_sabha)).data;
            } catch (error) {
                console.error("Error fetching data", error);
            }
        },

        async SearchByCat() {
            this.checkFormas();
            if (!this.checkEmptyErras()) {
                this.$refs.alert.showAlert('error', 'Fill Required Field !');
            } else {
                this.CatObj.propsearch = ""; this.selectedProperty = null;
                const response = await axios.get(`/proplist/${this.rentObj.pra_sabha}/${this.CatObj.ward}/${this.CatObj.street}/${this.CatObj.mainc}`);
                this.propertydetails = response.data;
            }
        },
        async SearchByward() {
            this.selectedProperty = null;
            const response = await axios.get(`/wardproplist/${this.rentObj.pra_sabha}/${this.CatObj.ward}`);
            this.propertydetails = response.data;
        },
        async SearchByraod() {
            this.selectedProperty = null;
            const response = await axios.get(`/streetproplist/${this.rentObj.pra_sabha}/${this.CatObj.ward}/${this.CatObj.street}`);
            this.propertydetails = response.data;
        },

        // ═══════════════════════════════════════════════════════════════
        // ── populateCustomerDetails ──
        // Uses calculateArrears + loadPaymentStatus (PIV approach)
        // ═══════════════════════════════════════════════════════════════
        async populateCustomerDetails() {
            try {
                // 1. Fetch owner details
                const response = await axios.get(`/prownerdetails/${this.CatObj.assenum}/${this.rentObj.pra_sabha}`);
                if (!response.data || !response.data.length) {
                    this.$refs.alert.showAlert('error', 'No owner details found');
                    this.cusObj = { ...this.cusObj, name: "owner details Not found", address: "" };
                    return;
                }
                this.ownerdetails   = response.data;
                this.cusObj.name    = this.ownerdetails.map(o => o.cus_name).join(', ') || "";
                this.cusObj.address = this.ownerdetails[0].prop_address || "";
                this.assnum         = this.ownerdetails[0].asses_num;
                this.asspropId      = this.ownerdetails[0].property_id;

                // 2. Fetch sabha config
                this.theSabhaData    = (await axios.get('/PraSabhadata/' + this.rentObj.pra_sabha)).data;
                this.Sname           = 'tax';
                this.ipg             = this.theSabhaData[0].saba_ipg;
                this.assessVote      = this.theSabhaData[0].assess_vote;
                this.assessArrearsVote = this.theSabhaData[0].assess_arrears_vote;
                this.assessFineVote  = this.theSabhaData[0].assess_fine_vote;

                // 3. Fetch property details
                this.propDetails  = (await axios.get(`/sabapropid/${this.rentObj.pra_sabha}/${this.CatObj.assenum}`)).data;
                this.cusObj.fq    = this.propDetails[0].q_one_val;
                this.cusObj.sq    = this.propDetails[0].q_two_val;
                this.cusObj.tq    = this.propDetails[0].q_three_val;
                this.cusObj.foq   = this.propDetails[0].q_four_val;
                this.usedNum      = this.propDetails[0].used_num;
                this.CatObj.street = this.propDetails[0].street_id;
                this.CatObj.ward   = this.propDetails[0].ward_id;

                // 4. PIV-accurate arrears calculation
                await this.calculateArrears(this.CatObj.assenum);

                // 5. PIV-accurate payment status
                await this.loadPaymentStatus(this.CatObj.assenum);

                // 6. Reset checkboxes
                this.Annualchecked = false;
                this.qfourcheck = false; this.qthrecheck = false;
                this.qtwocheck  = false; this.qonecheck  = false;

            } catch (error) {
                console.error("Error fetching owner details:", error);
            }
        },

        // ═══════════════════════════════════════════════════════════════
        // ── Annual checkbox ──
        // Uses safePercent for 10% discount (integer-safe)
        // ═══════════════════════════════════════════════════════════════
        handleCheckboxChange() {
            this.errorMessage = "";
            if (!this.Annualchecked) {
                this.cusObj.yearlyval = "";
                this.cusObj.discval   = "";
                return;
            }
            if (!this.propDetails || !this.propDetails[0]) {
                this.errorMessage  = "Property details are not available.";
                this.Annualchecked = false;
                return;
            }
            const yearly_val   = this.propDetails[0].yearly_value;
            this.cusObj.yearlyval = yearly_val;
            const today        = new Date(this.serverDate);
            const strippedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const january31    = new Date(today.getFullYear(), 0, 31);

            if (strippedDate > january31) {
                this.errorMessage  = "The time to pay the full annual amount has passed.";
                this.Annualchecked = false;
            } else {
                // safePercent: integer-safe 10% discount
                const discountAmt     = this.safePercent(yearly_val, 10);
                this.cusObj.discval   = this.roundToTwo(discountAmt).toFixed(2);
                const discountedValue = this.roundToTwo(yearly_val - discountAmt);
                const arrears         = parseFloat(this.cusObj.arre) || 0;
                this.cusObj.payamountqaurter = (arrears === 0
                    ? discountedValue
                    : this.roundToTwo(discountedValue + arrears)
                ).toFixed(2);
            }
        },

        // ═══════════════════════════════════════════════════════════════
        // ── Quarter checkboxes ──
        // ═══════════════════════════════════════════════════════════════
        qoneChecked() {
            this.qOneErrorMessage = "";
            if (!this.propDetails?.[0]) {
                this.qOneErrorMessage = "Property details are not available.";
                this.qonecheck = false; return;
            }
            this.cusObj.fq = this.propDetails[0].q_one_val || 0;
        },
        qtwoChecked() {
            this.qtwoErrorMessage = "";
            if (!this.propDetails?.[0]) {
                this.qtwoErrorMessage = "Property details are not available.";
                this.qtwocheck = false; return;
            }
            this.cusObj.sq = this.propDetails[0].q_two_val;
        },
        qthreeChecked() {
            this.qthreeErrorMessage = "";
            if (!this.propDetails?.[0]) {
                this.qthreeErrorMessage = "Property details are not available.";
                this.qthrecheck = false; return;
            }
            this.cusObj.tq = this.propDetails[0].q_three_val;
        },
        qfourChecked() {
            this.qfourerrorMessage = "";
            if (!this.propDetails?.[0]) {
                this.qfourerrorMessage = "Property details are not available.";
                this.qfourcheck = false; return;
            }
            this.cusObj.foq = this.propDetails[0].q_four_val;
        },

        // ═══════════════════════════════════════════════════════════════
        // ── Helpers ──
        // ═══════════════════════════════════════════════════════════════
        getWardName(ward_id) {
            const ward = this.savedWards.find(m => m.ward_id === ward_id);
            return ward ? ward.ward : 'Unknown';
        },
        getStreetName(street_id) {
            const street = this.savedStreets.find(m => m.street_id === street_id);
            return street ? street.street_name : 'Unknown';
        },
        getCategoryName(cat_id) {
            const category = this.maincate.find(m => m.cat_id === cat_id);
            return category ? category.category_name : 'Unknown';
        },

        checkFormas() {
            this.resetCheckErras();
            if (!this.CatObj.ward)   this.aserrObj.wardErr.push("required");
            if (!this.CatObj.street) this.aserrObj.stretErr.push("required");
            if (!this.CatObj.mainc)  this.aserrObj.maincErr.push("required");
        },
        resetCheckErras() {
            this.aserrObj.wardErr = []; this.aserrObj.stretErr = []; this.aserrObj.maincErr = [];
        },
        checkEmptyErras() {
            for (var typeErr in this.aserrObj) { if (this.aserrObj[typeErr].length !== 0) return false; }
            return true;
        },
        resetCheckErr() {
            this.errorObj.disErr=[]; this.errorObj.proErr=[]; this.errorObj.praErr=[];
            this.errorObj.taxNumErr=[]; this.errorObj.PaymentErr=[]; this.errorObj.paydesErr=[];
            this.errorObj.wardErr=[]; this.errorObj.streetErr=[];
        },
        resetObjects() {
            this.rentObj.dis=""; this.rentObj.pro=""; this.rentObj.pra_sabha="";
            this.rentObj.paydes=""; this.rentObj.taxNum=""; this.rentObj.Payment="";
            this.rentObj.ward=""; this.rentObj.street="";
        },
        checkEmptyErr() {
            for (var typeErr in this.errorObj) { if (this.errorObj[typeErr].length !== 0) return false; }
            return true;
        },
        checkForm() {
            this.resetCheckErr();
            if (!this.rentObj.taxNum)  this.errorObj.taxNumErr.push("Please Enter Your Assessment Tax Number");
            if (!this.rentObj.ward)    this.errorObj.wardErr.push("Please Enter ward no");
            if (!this.rentObj.street)  this.errorObj.streetErr.push("Please Enter Street");
        },

        isFullyPaid(pid) {
            const paymentStatus = this.paymentData[pid];
            if (!paymentStatus) return false;
            return ['1','2','3','4'].every(q => paymentStatus[q]?.[0] === "Paid");
        },

        // ═══════════════════════════════════════════════════════════════
        // ── saveTemporyPayment ──
        // Uses PIV's getQuarterCost values (q*Values computed props)
        // ═══════════════════════════════════════════════════════════════
        async saveTemporyPayment(pid) {
            const currentYear = new Date(this.serverDate).getFullYear();
            const nextYear    = currentYear + 1;

            const quarters = [
                { name:'1', payment: this.cusObj.fq,  vals: this.q1Values, isChecked: this.qonecheck  },
                { name:'2', payment: this.cusObj.sq,  vals: this.q2Values, isChecked: this.qtwocheck  },
                { name:'3', payment: this.cusObj.tq,  vals: this.q3Values, isChecked: this.qthrecheck },
                { name:'4', payment: this.cusObj.foq, vals: this.q4Values, isChecked: this.qfourcheck },
            ];

            await this.loadPaymentStatus(pid);
            const isPaid = this.isFullyPaid(pid);
            const year   = isPaid ? nextYear : currentYear;

            if (this.Annualchecked) {
                // Annual payment record (quarter_num = 5)
                await axios.post("/savpaytemp/", {
                    sb_code:        this.sabha,
                    property_id:    this.ownerdetails[0]?.property_id || "",
                    quarter_num:    '5',
                    paid_amount:    this.cusObj.payamountqaurter,
                    paid_date:      this.formattedDate(),
                    discount_given: this.cusObj.discval,
                    paid_year:      year,
                    fine_amount:    '0',
                    record_date:    this.formattedDate(),
                });
            } else {
                // Individual quarter records — use PIV-computed cashNeeded & discount
                for (const quarter of quarters) {
                    if (!quarter.isChecked) continue;
                    await axios.post("/savpaytemp/", {
                        sb_code:        this.sabha,
                        property_id:    this.ownerdetails[0]?.property_id || "",
                        quarter_num:    quarter.name,
                        paid_amount:    quarter.vals.cashNeeded,
                        paid_date:      this.formattedDate(),
                        discount_given: quarter.vals.discount || "0",
                        paid_year:      year,
                        fine_amount:    quarter.vals.fine    || "0",
                        record_date:    this.formattedDate(),
                    });
                }
            }
        },

        // ═══════════════════════════════════════════════════════════════
        // ── Continuetoinvoice ──
        // ═══════════════════════════════════════════════════════════════
        async Continuetoinvoice() {
            if (this.propDetails.length > 0 && parseFloat(this.paybleAmount) > 0) {
                const paymentmonth = parseInt(new Date(this.serverDate).getMonth()) + 1;
                const paymentyear  = new Date(this.serverDate).getFullYear();
                this.onlinPaydata  = (await axios.get('/genarateinvonline/' + this.rentObj.pra_sabha)).data;
                this.lastGennum    = parseInt(this.onlinPaydata[0].gen_num);
                this.InvouceNum    = (this.rentObj.pra_sabha.concat(this.currentDate.getMonth() + 1, this.currentDate.getFullYear(), this.lastGennum));
                this.nextid        = this.lastGennum + 1;
                await axios.put('/updateinvonline/' + this.rentObj.pra_sabha, { gen_num: this.nextid });

                // Tax amount = payable minus fine (fine goes on separate line)
                const payamount = this.roundToTwo(parseFloat(this.paybleAmount) - parseFloat(this.totalFine)).toFixed(2);

                await this.saveTemporyPayment(this.ownerdetails[0].property_id);

                const data = {
                    invoice_num:       this.InvouceNum,
                    sabha:             this.sabha,
                    cus_nic:           this.ownerdetails[0]?.property_id || "",
                    cus_name:          this.cusObj.name,
                    cus_contact:       this.ownerdetails[0]?.cus_contact || "",
                    cus_address:       this.cusObj.address,
                    sb_rate_head:      this.assessVote,
                    description:       this.descriptionText,
                    amount:            payamount,
                    stamp:             "0",
                    discount:          this.totalDiscount,
                    shoptotalarrears:  "0",
                    paymonth:          `${paymentmonth}-${paymentyear}`,
                    vat:               "0",
                    shopdid:           this.ownerdetails[0]?.property_id || "0",
                    date:              this.formattedDate(),
                    sub_nic:           this.user.cus_nic,
                };

                const arrears = parseFloat(this.cusObj.arre) || 0;
                if (arrears <= 0) {
                    await axios.post("/assreceipttemp/", data);
                } else {
                    await axios.post("/assreceipttemp/", { ...data, amount: this.paybleAmount, sb_rate_head: this.assessArrearsVote });
                }

                if (parseFloat(this.totalFine) > 0) {
                    await axios.post("/assreceipttemp/", {
                        ...data,
                        description:  'Fine Amount',
                        amount:       this.totalFine,
                        sb_rate_head: this.assessFineVote,
                        discount:     "0",
                    });
                }

                const onlineData = {
                    online_cus_nic:      this.ownerdetails[0]?.property_id || "",
                    online_sabha_code:   this.sabha,
                    online_invoice_num:  this.InvouceNum,
                    online_pay_amount:   this.paybleAmount,
                    online_pay_month:    paymentmonth,
                    online_pay_year:     paymentyear,
                    online_pay_des:      this.descriptionText,
                    pay_type:            "assessmenttax",
                    vote:                this.pay_vote,
                    online_pay_date:     this.formattedDate(),
                };
                await axios.post("/onlinepaymenttemp/", onlineData);

                // Bill record
                await axios.post("/assreceiptbilltemp/", {
                    invoice_num:     this.InvouceNum,
                    sabha:           this.sabha,
                    property_id:     this.ownerdetails[0]?.property_id || "",
                    ward:            this.getWardName(this.CatObj.ward),
                    street:          this.getStreetName(this.CatObj.street),
                    assess_number:   this.assnum,
                    used_number:     this.usedNum,
                    cus_name:        this.cusObj.name,
                    cus_contact:     this.ownerdetails[0]?.cus_contact || "",
                    cus_address:     this.cusObj.address,
                    description:     this.descriptionText,
                    excess_arrears:  this.cusObj.arre,
                    quater_amount:   this.totalAmountPayQ,
                    fine:            this.totalFine,
                    discount:        this.totalDiscount,
                    paid_amount:     this.paybleAmount,
                    paymonth:        `${paymentmonth}-${paymentyear}`,
                    sub_nic:         this.user.cus_nic,
                });

                sessionStorage.setItem('taxDetails', JSON.stringify({
                    invoice_num:     this.InvouceNum,
                    sabha_code:      this.sabha,
                    property_id:     this.ownerdetails[0]?.property_id || "",
                    ward:            this.getWardName(this.CatObj.ward),
                    street:          this.getStreetName(this.CatObj.street),
                    assess_number:   this.assnum,
                    used_number:     this.usedNum,
                    cus_name:        this.cusObj.name,
                    cus_contact:     this.ownerdetails[0]?.cus_contact || "",
                    cus_address:     this.cusObj.address,
                    remark:          this.descriptionText,
                    excess_arrears:  this.cusObj.arre,
                    quater_amount:   this.totalAmountPayQ,
                    fine:            this.totalFine,
                    discount:        this.totalDiscount,
                    paid_amount:     this.paybleAmount,
                    paymonth:        `${paymentmonth}-${paymentyear}`,
                    sub_nic:         this.user.cus_nic,
                }));

                this.$router.push("/assessmenttaxinvoice");
            } else {
                this.$refs.alert.showAlert('error', 'Please select Property and Payments');
            }
        },

        btnenable() {
            if (this.checkVal == true) {
                document.getElementById('formResponse').style.display = 'none';
                this.disableButton = true;
            } else {
                document.getElementById('formResponse').style.display = 'block';
                this.disableButton = !this.disableButton;
            }
        },
    },

    components: { VueBasicAlert },
};
</script>

<style scoped>
input[type="button"] {
   background: none; color: inherit; border: none;
   padding: 0; font: inherit; cursor: pointer; outline: inherit;
}
hr { border-top: 3px solid #057835fa; width: 100%; }
::placeholder { color: white; }

.menu-section {
   padding: 1rem 2%; min-height: 75vh;
   background-image: url("../assets/images/background3.jpg");
   background-repeat: no-repeat; background-size: cover;
}
.menu-section .menu-tabs { flex: 0 0 100%; text-align: center; background: #5e5c5cda; }
.menu-section .menu-tabs .menu-tab-item {
   display: inline-block; cursor: pointer; padding: 5px 30px;
   border-radius: 30%; font-size: 20px; color: whitesmoke;
   font-weight: 500; text-transform: capitalize; transition: all 0.3s ease; margin: 0;
}
.project-list>tbody>tr>td { padding: 12px 8px; font-size: small; }
h4 { padding-left: 1%; }

.register-container { padding: 2rem 2%; }
.register-container .register-form-container { background: #fff; }
.register-container .register-form-container form {
   width: 100%; box-shadow: 0 1rem 1rem rgba(0,0,0,0.05);
   border: 0.1rem solid rgba(0,0,0,0.2); padding: 1rem;
   border-radius: 0.5rem; animation: fadeUp 0.4s linear;
}
.register-container .register-form-container form h3 {
   padding-bottom: 1rem; font-size: 2rem;
   text-transform: uppercase; color: #130f40; margin: 0;
}
.register-container .register-form-container form .form-control {
    margin: 0.7rem 0; border-radius: 0.5rem; background: #f7f7f7;
    font-size: 1.3rem; color: #130f40; text-transform: none;
    width: 100%; border: bottom 1px solid;
}
.project-list>tbody>tr>td .input-box {
    border-radius: 0.5rem; background: #e4e3e3;
    font-size: 1.5rem; color: #130f40; width: 100%; border: 1px solid;
}
.register-container .register-form-container form label { font-size: 5rem; margin: 0; padding: 0; float: left; }
.register-container .register-form-container form span { font-size: 18px; padding-left: 5px; padding-right: 40px; display: block; overflow: hidden; }
.register-container .register-form-container form .btn { margin: 1rem 0; width: 10%; text-align: center; background-color: #620a0a; height: 30px; font-size: 1rem; color: #000; }
.btn1 { margin: 1rem 0; width: 10%; text-align: center; background-color: #620a0a; height: 30px; font-size: 1rem; color: #000; }
.register-container .register-form-container form p { padding-top: 1rem; font-size: 1rem; color: #666; margin: 0; text-align: justify; }
p { padding-top: 1rem; font-size: 0.5rem; color: #666; margin: 0; text-align: justify; text-transform: none; }
.register-container .register-form-container form p a { color: #27ae60; }
.register-container .register-form-container form p a:hover { color: #130f40; text-decoration: underline; }
.register-container .register-form-container form .form-group { margin: 0; font-size: 5.5rem; }
.register-container .register-form-container form .form-group .error-mess { font-size: 1.5rem; position: relative; color: rgb(243,47,47); margin: 0; padding: 0; }

.shroff-container { background-color: #ffffff09; height: auto; font-size: 16px; }
.project-list>tbody>tr>td { padding: 12px 8px; }
.project-list>tbody>tr>td .avatar { width: 22px; border: 1px solid #CCC; }
.bg-light-gray { background-color: #f7f7f7; }
.table td, .table th { vertical-align: top; border-top: 1px solid #dee2e6; width: 30%; vertical-align: bottom; font-size: 1.5rem; }
.table-responsive { padding-left: 2.5%; width: 100%; align-items: center; }

.action-btn { background-color: #0da9ef; margin-right: 10px; }
.cancel-btn, .paid-btn { background-color: red; }
.action-btn:hover { background-color: #27ae60; }
.order-section form .row .input-box { width: 49%; padding: 1.8rem 0; }

.shroff-container { padding: 2rem 2%; }
.shroff-container .shroff-form-container { background: #fff; }
.shroff-container .shroff-form-container form {
   width: 100%; box-shadow: 0 1rem 1rem rgba(0,0,0,0.05);
   border: 0.1rem solid rgba(0,0,0,0.2); padding: 2rem;
   border-radius: 0.5rem; animation: fadeUp 0.4s linear;
}
.shroff-container .shroff-form-container form h3 { padding-bottom: 1rem; font-size: 2rem; text-transform: uppercase; color: #130f40; margin: 0; }
.shroff-container .shroff-form-container form .form-control {
    margin: 0.7rem 0; border-radius: 0.5rem; background: #f7f7f7;
    font-size: 1.3rem; color: #130f40; text-transform: none;
    width: 100%; border: margin-bottom;
}
.shroff-container .shroff-form-container form label { font-size: 1.2rem; margin: 0; padding: 0; float: left; }
.shroff-container .shroff-form-container form span { font-size: 18px; padding-left: 5px; padding-right: 40px; }
.shroff-container .shroff-form-container form .btn { width: 25%; text-align: center; font-size: small; background-color: #620a0a; height: 3rem; color: #f4efef; }
.shroff-container .shroff-form-container form .table { width: 95%; text-align: center; font-size: small; background-color: #f7f7f7; }
.shroff-container .shroff-form-container form .Addbtn { width: 5rem; padding-top: 1.9rem; padding-left: 3rem; }
.shroff-container .shroff-form-container form p { padding-top: 1rem; font-size: 1.5rem; color: #666; margin: 0; }
.shroff-container .shroff-form-container form .error-mess { font-size: 1.2rem; position: relative; color: rgb(243,47,47); margin: 0; padding: 0; }
.shroff-container .shroff-form-container form p a { color: #27ae60; }
.shroff-container .shroff-form-container form p a:hover { color: #130f40; text-decoration: underline; }
.shroff-container .shroff-form-container form .form-group { margin: 0; }
.shroff-container .shroff-form-container form .form-group .error-mess { font-size: 1.5rem; position: relative; color: rgb(243,47,47); margin: 0; padding: 2rem 1.2rem; }

.action-btn, .cancel-btn, .paid-btn { width: 100px; height: 25px; color: white; text-transform: capitalize; }
.action-btn { background-color: #0da9ef; margin-right: 10px; }
.cancel-btn, .paid-btn { background-color: red; }
.action-btn:hover { background-color: #27ae60; }

.icons { height: 4.5rem; width: 5rem; line-height: 4.5rem; font-size: 2rem; background: #eb8e02; color: #f8f7fc; border-radius: .5rem; margin-left: .3rem; cursor: pointer; text-align: center; }
h5 { color: #08031c; text-align: center; }
pre { font-size: 1.0rem; text-transform: uppercase; color: #130f40; text-align: right; padding-top: 1%; padding-right: 2%; }
.invoice { padding: 2rem 15%; }
</style>